import { VehicleRecord } from '../types';

const getVehicleRecords = (response: any): VehicleRecord[] => {
  if (!response.results) {
    return [];
  }

  const vehicles: VehicleRecord[] = response.results[0].hits || [];

  return vehicles.map((vehicle: VehicleRecord) => ({
    ...vehicle,
    name: `${vehicle.Make} ${vehicle.Model} ${vehicle.Series} ${vehicle.PS} ${vehicle.FuelType} ${vehicle.YearFrom} - ${vehicle.YearTo}`,
  }));
};

export default getVehicleRecords;
